import { adminConstants } from '../constants';

export const adminReducer = (state = {}, action) => {
    // delete password for security
    if(action && action.payload && action.payload.hasOwnProperty('password')) delete action.payload.password;

    switch(action.type) {
        case adminConstants.GET_ALL_ADMINS_REQEUST:
            return {
                ...state,
                getAllAdminsProcess: true
            }

        case adminConstants.GET_ALL_ADMINS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                getAllAdminsProcess: false,
                getAllAdminsError: false
            }

        case adminConstants.GET_ALL_ADMINS_FAILURE:
            return {
                ...state,
                getAllAdminsProcess: false,
                getAllAdminsError: true
            }

        default: 
            return state;
    }
}

export default adminReducer;


// WEBPACK FOOTER //
// ./src/reducers/admin.js